import { client } from '@/common-utils/libraries/axios/axios';
import CUSTOMIZATION from '../apiUrls';

const mutationSaveCustomization = (onSuccess, onError) => {
    return {
        mutationFn: (packageCustomizationData) => {
            return client.post(CUSTOMIZATION.CREATE_PACKAGE_CUSTOMIZATION.url, packageCustomizationData);
        },
        // onError: (error, variables, context)
        onError: (error) => {
            onError(error);
        },
        // onSuccess: (data, variables, context)
        onSuccess: (data) => {
            onSuccess(data);
        },
        // onSettled: (data, error, variables, context)
        onSettled: () => {
            // Error or success... doesn't matter!
        }
    };
};

export default mutationSaveCustomization;